import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-panel-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-panel-header.component.html',
  styleUrl: './app-panel-header.component.css'
})
export class AppPanelHeaderComponent {
  @Input() title: string = '';
  @Input() icon: string = 'fa-user';
  @Input() editMode: boolean = false;
  @Input() editButtonText: string = 'Edit';
  @Input() saveButtonText: string = 'Save Changes';
  @Output() editModeChange = new EventEmitter<boolean>();
  @Output() save = new EventEmitter<void>();

  toggleEditMode(): void {
    this.editMode = !this.editMode;
    this.editModeChange.emit(this.editMode);
  }

  onSave(): void {
    this.save.emit();
    this.editMode = false;
    this.editModeChange.emit(this.editMode);
  }

  onCancel(): void {
    this.editMode = false;
    this.editModeChange.emit(this.editMode);
  }
}
